import {
  Datagrid,
  DateField,
  DeleteWithConfirmButton,
  EditButton,
  ExportButton,
  List,
  TextField,
  TopToolbar,
} from "react-admin";
import ApcMediaField from "../../common/ApcMediaField";

const GalleryListActions = () => (
  <TopToolbar>
    <ExportButton />
  </TopToolbar>
);

export default () => {
  return (
    <List actions={<GalleryListActions />}>
      <Datagrid rowClick="show" optimized>
        <TextField source="id" />
        <ApcMediaField source="url" />
        <TextField source="title" />
        <TextField source="galleryId" />
        <DateField source="createdAt" />
        <EditButton />
        <DeleteWithConfirmButton />
      </Datagrid>
    </List>
  );
};
